import type { DeepPartial } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useSaveAccountInsulin as useSaveAccountInsulinApi,
  useCreateAccountInsulin,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import type { DeepReadonlyObject } from "rxdb"

import { transformAccountInsulin } from "./transformAccountInsulin"
import {
  useCreateCollectionItem,
  useUpdateCollectionItem,
} from "src/hooks/rxdb"
import { CollectionKey } from "src/types"
import type { AccountInsulin } from "src/types"

type PartialAccountInsulin = DeepReadonlyObject<DeepPartial<AccountInsulin>>

export function useSaveAccountInsulin() {
  const createAccountInsulin = useCreateCollectionItem(
    CollectionKey.AccountInsulin,
    "account_insulin",
    useCreateAccountInsulin,
    transformAccountInsulin,
  )

  const updateAccountInsulin = useUpdateCollectionItem(
    CollectionKey.AccountInsulin,
    "account_insulin",
    useSaveAccountInsulinApi,
    transformAccountInsulin,
  )

  return useCallback(
    (accountInsulin: PartialAccountInsulin) => {
      const {
        id,
        insulin_id,
        ...otherProps
      } = accountInsulin

      if (id) {
        return updateAccountInsulin({
          ...otherProps,
          id: Number(id),
          insulin_id: insulin_id ? Number(insulin_id) : null,
        })
      }

      return createAccountInsulin({
        ...otherProps,
        insulin_id: insulin_id ? Number(insulin_id) : null,
      })
    },
    [
      createAccountInsulin,
      updateAccountInsulin,
    ],
  )
}
